export const NAME = 'notifications'

export const GET_NOTIFICATIONS_LOADING = `${NAME}/GET_NOTIFICATIONS/LOADING`
export const GET_NOTIFICATIONS = `${NAME}/GET_NOTIFICATIONS`
export const ADD_NOTIFICATION = `${NAME}/ADD_NOTIFICATION`

export const NOTIFICATION_TYPES = {
  BANNER: 'BANNER'
}
export const NOTIFICATION_LEVELS = {
  ALERT: 'ALERT',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFORMATION: 'INFORMATION'
}
export const BANNER_TYPES = {
  ALERT: 'ALERT',
  REDIRECT: 'REDIRECT',
  NOTIFICATION: 'NOTIFICATION'
}
export const NOTIFICATION_LEVELS_SORT_ORDER = {
  ALERT: 0,
  INFORMATION: 1
}
